"use strict";

document.addEventListener('DOMContentLoaded', () => {

  // GET USERLOCALE
  var userLocale = document.documentElement.lang.substring(0, 2);
  if (userLocale.includes('uk')) {
    userLocale.replace("uk", 'gb')
  }
  userLocale = userLocale.toUpperCase();

  // RESIZE

  function checkWindowWidth() {
    let isSmallScreen = false;

    function handleResize() {
      if (window.innerWidth < 768) {
        return isSmallScreen = true;
      }
      return isSmallScreen = false;
    }

    // Initial check on page load
    return handleResize();
  }

  // TRACK IF AN ELEMENT IS HALFWAY INSIDE THE VIEWPORT

  function addClassWhenHalfwayInView(targetElement, className) {
    function isElementHalfwayInsideViewport() {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const halfwayPoint = viewportHeight / 2;
      const rect = targetElement.getBoundingClientRect();
      const elementTop = rect.top;
      const elementBottom = rect.bottom;

      return elementTop < halfwayPoint && elementBottom > 0;
    }

    function handleScroll() {
      if (isElementHalfwayInsideViewport()) {
        targetElement.classList.add(className);
      } else {
        targetElement.classList.remove(className);
      }
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll();
  }

  // MAIN NAVIGATION

  // JS remains largely the same with minor adjustments to ensure links are crawlable and interactive elements proceed with enhancements

  const body = document.querySelector('body');
  const pgHeader = document.querySelector('.pg-header');
  const toggleNav = document.querySelector('.toggle-nav');
  const toggleLanguageSwitcher = document.querySelector('.toggle-location-switcher');
  const toggleSignUpAlerts = document.querySelector('.main-nav .btn');

  const handleNavToggle = () => {
    pgHeader.classList.remove('location-switcher-is-open');
    pgHeader.classList.toggle('main-nav-is-open');
    // body.classList.toggle('no-scroll');
  };

  const handleLangSwitcherToggle = () => {
    pgHeader.classList.remove('main-nav-is-open');
    pgHeader.classList.toggle('location-switcher-is-open');
    // body.classList.toggle('no-scroll');
  };

  if (toggleSignUpAlerts) {
    toggleSignUpAlerts.addEventListener('click', () => {
      pgHeader.classList.remove('main-nav-is-open');
      body.classList.remove('no-scroll');
    });
  }

  if (toggleNav) {
    toggleNav.addEventListener('click', handleNavToggle);
  }

  if (toggleLanguageSwitcher) {
    toggleLanguageSwitcher.addEventListener('click', handleLangSwitcherToggle);
  }

// Language Switcher

  const lang_options = {
    GB: ['uk-en'],
    IE: ['ie-en'],
    FR: ['fr-en', 'fr-fr'],
    IT: ['it-en', 'it-it'],
    ES: ['es-en', 'es-es'],
    DE: ['de-en', 'de-de', 'de-ar', 'de-pl', 'de-tr', 'de-es', 'de-ro', 'de-bg', 'de-cs', 'de-ru'],
    AT: ['at-en', 'at-de'],
    BE: ['be-en', 'be-fr', 'be-nl'],
    NL: ['nl-en', 'nl-nl']
  };

  const locations = document.querySelectorAll('input[name="location"]');
  const languages = document.querySelectorAll('.language-switcher-list li');

  locations.forEach((location) => {
    const defaultLang = location.getAttribute('data-default-lang');

    location.addEventListener('click', () => {
      languages.forEach((langItem) => {
        langItem.style.display = 'none';
      });

      lang_options[location.value].forEach((language) => {
        document.querySelector(`[data-language='${language}']`).style.display = 'block';
      });

      document.querySelector(`#${defaultLang}-language-switch`).checked = true;
    });
  });

  const switcherSubmit = document.getElementById('switcher-submit');

  if (switcherSubmit) {
    switcherSubmit.addEventListener('click', (e) => {
      e.preventDefault();

      const location = document.querySelector('input[name="location"]:checked').value;
      const language = document.querySelector('input[name="language"]:checked').value;
      const selectedLanguageElement = document.querySelector('input[name="language"]:checked');
      const selectedLanguageEnglishId = selectedLanguageElement.closest('li').getAttribute('data-language');
      const pathname = window.location.pathname;
      const urlParams = new URLSearchParams(window.location.search);
      const locationQueryParam = urlParams.get('location') || userLocale;
      const isLanguageAvailable = lang_options[location] && lang_options[location].includes(selectedLanguageEnglishId);

      if (document.body.classList.contains('single-post')) {
        let blogRedirectUrl = '';
        if(language === 'uk-en') {
          blogRedirectUrl = `/blog/${pageName}`;
        } else {
          blogRedirectUrl = `/${language}/blog/${pageName}`;
        }
        window.location.href = `${blogRedirectUrl}`;
      } else if (location === locationQueryParam && isLanguageAvailable) {
        const roleIndex = pathname.indexOf('/role/');
        let rolePath = '';

        if (roleIndex !== -1) {
          rolePath = pathname.substring(roleIndex + '/role/'.length).replace(/\/$/, '');
        }

        const roleId = rolePath ? `/${rolePath}` : '';
        let baseRedirectUrl = '';
        if(language === 'uk-en') {
          baseRedirectUrl = `/${pageName}${roleId}`;
        } else {
          baseRedirectUrl = `/${language}/${pageName}${roleId}`;
        }

        window.location.href = `${baseRedirectUrl}`;

      } else {
        let fallbackRedirectUrl = '';
        if(language === 'uk-en') {
          fallbackRedirectUrl = `/${pageName}`;
        } else {
          fallbackRedirectUrl = `/${language}/${pageName}`;
        }

        window.location.href = `${fallbackRedirectUrl}`;
      }
    });
  }

  // GET CURRENT LOCATION

  function getCurrentLocation(ctaElem) {
    if (ctaElem) {
      ctaElem.addEventListener('click', (e) => {
        console.log('here first');
        e.preventDefault();

        if ('geolocation' in navigator) {
          console.log('here second');
          navigator.geolocation.getCurrentPosition(
            (position) => {
              console.log('here third');
              const apiKey = 'AIzaSyCoIJwYY2BGKklhrcdAjxmAC5-P56tLRbg';
              const { latitude } = position.coords;
              const { longitude } = position.coords;

              // Prepare the API request URL
              const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

              // Send the API request using fetch
              fetch(url)
                .then((response) => response.json())
                .then((data) => {
                  console.log('here fourth');
                  // Check if the API call was successful
                  if (data.status === 'OK') {
                    // Get the first result
                    const firstResult = data.results[0];

                    // Find the postal town in the address components
                    let postalTown = '';
                    for (const component of firstResult.address_components) {
                      if (component.types.includes('postal_town')) {
                        postalTown = component.long_name;
                        break;
                      }
                    }

                    // Output the postal town
                    if (postalTown) {
                      console.log('here fifth');
                      // document.querySelector('input[name="search_location"]').value = postalTown;
                      const searchLocationField = document.querySelector('input[name="search_location"]');
                      searchLocationField.value = postalTown;
                      searchLocationField.focus();
                    } else {
                      // ('Postal town not found for the provided coordinates.');
                    }
                  } else {
                    // console.log('Error: Unable to fetch data from the Google Maps API.');
                  }
                })
                .catch((error) => console.error('Error:', error));
            },
            (error) => {
              console.error('Error getting geolocation:', error);
            },
          );
        } else {
          console.error('Geolocation is not available in this browser.');
        }
      });
    }
  }

  const getLocation = document.getElementById('get-location');
  const getLocationVwo = document.getElementById('get-location-vwo');

  getCurrentLocation(getLocation);
  getCurrentLocation(getLocationVwo);

  // APPLICATION PROCESS

  const applicationStepsOuter = document.querySelector('.application-process-outer');

  if (applicationStepsOuter) {
    addClassWhenHalfwayInView(applicationStepsOuter, 'is-animating');
  }

  // SIDE SCROLLER

  const featuredRolesScrollers = document.querySelectorAll('.featured-roles');

  featuredRolesScrollers.forEach((el) => {
    const sideScrollerNext = el.querySelector('.side-scroller-control__next');
    const sideScrollerPrev = el.querySelector('.side-scroller-control__prev');
    const scroller = el.querySelector('.side-scroller');

    if (sideScrollerNext) {
      sideScrollerNext.addEventListener('click', () => {
        scroller.scrollLeft += 350;
      });
    }
    if (sideScrollerPrev) {
      sideScrollerPrev.addEventListener('click', () => {
        scroller.scrollLeft -= 350;
      });
    }
  });

  const driverStoriesScrollers = document.querySelectorAll('.driver-stories');

  driverStoriesScrollers.forEach((el) => {
    const sideScrollerNext = el.querySelector('.side-scroller-control__next');
    const sideScrollerPrev = el.querySelector('.side-scroller-control__prev');
    const scroller = el.querySelector('.side-scroller');

    sideScrollerNext.addEventListener('click', () => {
      scroller.scrollLeft += 350;
    });

    sideScrollerPrev.addEventListener('click', () => {
      scroller.scrollLeft -= 350;
    });
  });

  // ACCORDION

  let openCurrentAccordionBlock = '';
  const accordions = document.querySelectorAll('.accordion-block');
  const accordionToggles = document.querySelectorAll('.accordion-block__toggle');

  accordions.forEach((el) => {
    const currentAccordionToggle = el.querySelector('.accordion-block__toggle');
    const currentAccordionAnswer = el.querySelector('.accordion-block__answer');

    currentAccordionToggle.addEventListener('click', () => {
      // remove is-active from all here
      accordionToggles.forEach((el) => {
        el.classList.remove('is-active');
      });

      const allAccordionAnswers = document.querySelectorAll('.accordion-block__answer');

      allAccordionAnswers.forEach((el) => {
        el.classList.remove('is-open');
      });

      if (openCurrentAccordionBlock != currentAccordionAnswer.id) {
        currentAccordionAnswer.classList.add('is-open');
        // then add is-active to the clicked one
        currentAccordionToggle.classList.add('is-active');
        openCurrentAccordionBlock = currentAccordionAnswer.id;
      } else {
        openCurrentAccordionBlock = '';
      }
    });
  });

  // NEWSLETTER MODAL

  const newsletterModalToggles = document.querySelectorAll('.toggle-newsletter-modal');
  const newsletterModal = document.querySelector('.modal-overlay');

  newsletterModalToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      newsletterModal.classList.toggle('is-visible');
      body.classList.toggle('no-scroll');
    });
  });

  // COUNTRY MODAL

  const countryModalToggles = document.querySelectorAll('.toggle-country-modal');
  const countryModal = document.querySelector('.country-modal-overlay');

  countryModalToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      countryModal.classList.toggle('is-visible');
      body.classList.toggle('no-scroll');
    });
  });

  // ANIMATED STATS

  const statsGrid = document.querySelector('.stats-grid-outer');

  if (statsGrid) {
    addClassWhenHalfwayInView(statsGrid, 'is-animating');
  }

  if (statsGrid) {
    const statNumbers = document.querySelectorAll('.stat__number');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        statNumbers.forEach((stat) => {
          const statVal = parseFloat(stat.getAttribute('data-value'));
          const countUp = new CountUp(stat, 0, statVal, 0, 3);
          if (entry.isIntersecting) {
            countUp.start();
          } else {
            countUp.reset();
          }
        });
      });
    });

    observer.observe(statsGrid);
  }

  // SHOW/HIDE MAP

  const rolesParent = document.querySelector('.roles-outer');
  const openMap = document.querySelector('.open-map');
  const closeMap = document.querySelector('.close-map');
  const rolesContainer = document.querySelector('.roles-list');
  const mapContainer = document.querySelector('.roles-map-outer');
  const map = document.querySelector('.roles-map');

  if (rolesContainer) {
    const rolesContainerHeight = rolesContainer.offsetHeight;
    const mapHeight = map.offsetHeight;

    function handleViewportChange(mq) {
      if (mq.matches) {
        openMap.addEventListener('click', () => {
          rolesParent.classList.add('map-is-visible');

          if (mapHeight >= rolesContainerHeight) {
            rolesContainer.style.height = `${mapHeight}px`;
          } else {
            mapContainer.style.height = `${rolesContainerHeight}px`;
            map.style.position = 'sticky';
          }
        });

        closeMap.addEventListener('click', () => {
          rolesParent.classList.remove('map-is-visible');

          rolesContainer.style.height = '';
          mapContainer.style.height = '';
          map.style.position = '';
        });
      } else {
        openMap.addEventListener('click', () => {
          rolesParent.classList.add('map-is-visible');
          rolesContainer.style.height = `${mapHeight}px`;
        });

        closeMap.addEventListener('click', () => {
          rolesParent.classList.remove('map-is-visible');
          rolesContainer.style.height = '';
        });
      }
    }

    function handleClick() {
      console.log('Element clicked!');
    // Add other actions when the element is clicked
    }

    const mediaQuery = window.matchMedia('(min-width: 768px)');
    handleViewportChange(mediaQuery); // Initial check

    // Add event listener for viewport changes
    mediaQuery.addEventListener('change', (event) => {
      handleViewportChange(event.currentTarget);
    });
  }

  // BACK TO TOP

  const backToTop = document.querySelector('.back-to-top');

  if (backToTop) {
    backToTop.addEventListener('click', () => {
      window.scrollTo(0, 0);
      location.reload();
    });
  }

  // URL decoration

  (function () {
    const domainsToDecorate = [
      'driverexpress.com', // add or remove domains (without https or trailing slash)

    ];
    const queryParams = [
      'utm_medium', // add or remove query parameters you want to transfer
      'utm_source',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ];
    // do not edit anything below this line
    const links = document.querySelectorAll('a');

    // check if links contain domain from the domainsToDecorate array and then decorates
    for (let linkIndex = 0; linkIndex < links.length; linkIndex++) {
      for (let domainIndex = 0; domainIndex < domainsToDecorate.length; domainIndex++) {
        if (links[linkIndex].href.indexOf(domainsToDecorate[domainIndex]) > -1 && links[linkIndex].href.indexOf('#') === -1) {
          links[linkIndex].href = decorateUrl(links[linkIndex].href);
        }
      }
    }
    // decorates the URL with query params
    function decorateUrl(urlToDecorate) {
      const originalURL = urlToDecorate;
      urlToDecorate = (urlToDecorate.indexOf('?') === -1) ? `${urlToDecorate}?` : `${urlToDecorate}&`;
      const collectedQueryParams = [];
      for (let queryIndex = 0; queryIndex < queryParams.length; queryIndex++) {
        if (getQueryParam(queryParams[queryIndex])) {
          collectedQueryParams.push(`${queryParams[queryIndex]}=${getQueryParam(queryParams[queryIndex])}`);
        }
      }
      if (collectedQueryParams.length) {
        return urlToDecorate + collectedQueryParams.join('&');
      }
      return originalURL;
    }

    // borrowed from https://stackoverflow.com/questions/831030/
    // a function that retrieves the value of a query parameter
    function getQueryParam(name) {
      if (name = (new RegExp(`[?&]${encodeURIComponent(name)}=([^&]*)`)).exec(window.location.search)) return decodeURIComponent(name[1]);
    }
  }());

  const myDropzone = document.getElementById('myDropzone');
  if (myDropzone) {
    myDropzone.addEventListener('dragover', (e) => {
      e.preventDefault();
    });

    myDropzone.addEventListener('drop', (e) => {
      document.getElementById('file').files = e.dataTransfer.files;
      e.preventDefault();
    });

    myDropzone.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById('file').click();
    });
  }

  const file = document.getElementById('file');
  if (file) {
    file.addEventListener('change', (event) => {
      const file = event.target.files[0];
      const validTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      const fileInfoElement = document.getElementById('fileInfo');

      if (file) {
        // Calculate file size in MB and format it to two decimal places
        const fileSizeMB = (file.size / 1024 / 1024).toFixed(2);
        const fileInfoText = `${file.name} - ${fileSizeMB}MB`;

        // Check if the file type is valid
        if (!validTypes.includes(file.type)) {
          alert('Invalid file type. Only PDF and DOC/DOCX files are allowed.');

          // Clear the selected file
          event.target.value = '';

          // Clear the file info text
          fileInfoElement.innerText = '';
        } else {
          // Update the text of the uploadedFile element
          fileInfoElement.innerText = fileInfoText;
        }
      } else {
        // Clear the file info text if no file is selected
        fileInfoElement.innerText = fileInfo.dataset.uploadfiletext ? fileInfo.dataset.uploadfiletext : 'Upload file';
      }
    });
  }

  // var myDropzone = new Dropzone("#myDropzone", {
  //   url: "/upload.php",
  //   paramName: "file", // The name that will be used to transfer the file
  //   maxFilesize: 15, // MB
  //   maxFiles: 1, // Max number of files
  //   acceptedFiles: ".jpg,.jpeg,.png,.pdf", // Allowed file types
  //   dictDefaultMessage: `
  //     <span class="dropzone-icon">
  //       <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="m67.74 0h-55.56v100s75.65 0 75.65 0v-79.91zm1.16 5.28 14.14 14.14h-14.14zm-53.82 91.81v-94.18h50.91v19.41h18.93v74.76h-69.84z"/><path d="m22.63 14.22h30.8v2.91h-30.8z"/><path d="m22.63 26.17h17.44v2.91h-17.44z"/><path d="m44.71 26.17h17.44v2.91h-17.44z"/><path d="m22.63 38.12h54.29v2.91h-54.29z"/><path d="m58.69 53.05h18.22v2.91h-18.22z"/><path d="m22.63 67.98h54.27v2.91h-54.27z"/><path d="m22.63 53.05h30.8v2.91h-30.8z"/><path d="m49.77 82.92h27.15v2.91h-27.15z"/></svg>
  //       <p class="title title--sm">Upload file</p>
  //     </span>
  //     or drag and drop files here - max file size: 15MB
  //     `,
  //   addRemoveLinks: true // Adds a remove link for each file
  // });

  // Add event listeners for when files are added or removed
  // myDropzone.on("addedfile", function(file) {
  //   console.log("File added:", file);
  // });

  // myDropzone.on("removedfile", function(file) {
  //   console.log("File removed:", file);
  // });
});

// ------------------------------------
// MODAL
// ------------------------------------

const closeExistingApplicationModal = document.getElementById('closeExistingApplicationModal');

if (closeExistingApplicationModal) {
  closeExistingApplicationModal.addEventListener('click', (event) => {
    document.getElementById('ExistingApplicationModal').style.display = 'none';
  });
}

// ------------------------------------
// SUBMIT CONTROLLER
// ------------------------------------

window.onReCaptchaSuccess = function (token) {
  const event = window.reCaptchaEvent;
  onSubmitFormApplication(event, token);
}

function onSubmitFormApplication(e, token) {
  let error = false;

  const errors = document.querySelectorAll('.form-row-error');
  errors.forEach((error) => {
    error.style.display = 'none';
  });

  const driving_licence = document.getElementsByName('driving_licence');

  const first_name = document.querySelector('input[name="first_name"]');
  const last_name = document.querySelector('input[name="last_name"]');

  const email = document.querySelector('input[name="email"]');
  const emailPattern = email.getAttribute('pattern');
  const emailRegex = new RegExp(emailPattern);

  const phone = document.querySelector('input[name="phone"]');
  const phoneNumber = phone.value.trim().replace(/(?!^\+)\D/g, '');
  const phoneNumberError = window.phoneNumberError ?? false;
  const phonePattern = phone.getAttribute('pattern');
  const phoneRegex = new RegExp(phonePattern);

  const postcode = document.querySelector('input[name="postcode"]');
  const postcodePattern = postcode.getAttribute('pattern');
  const postcodeRegex = new RegExp(postcodePattern);

  const preferredLanguage = document.getElementById('preferred-language');
  const preferredLanguageItems = document.querySelectorAll('input[name="preferred-language[]"]');

  // const referral_code = document.querySelector('input[name="referral_code"]');
  const weekends = document.getElementsByName('weekends');
  const self_employed = document.getElementsByName('self-employed');

  const start_date = document.querySelector('input[name="start_date"]');
  const start_date_min_date = new Date(start_date.getAttribute('min'));

  const contact = document.querySelector('input[name="contact"]');

  const file = document.getElementById('file');
  const fileMaxSize = 15 * 1024 * 1024;

  if (driving_licence.length) {
    let selectedDriverLicenceValue = null;

    for (let i = 0; i < driving_licence.length; i++) {
      if (driving_licence[i].checked) {
        selectedDriverLicenceValue = driving_licence[i].value;
        break;
      }
    }

    if(selectedDriverLicenceValue !== "yes") {
      document.querySelector('#driving-licence-error').style.display = 'block';
      error = true;
    }
  }

  if (!first_name.value) {
    document.querySelector('#fn-error').style.display = 'block';
    error = true;
  }

  if (!last_name.value) {
    document.querySelector('#ln-error').style.display = 'block';
    error = true;
  }

  if (!email.value) {
    document.querySelector('#email-error').style.display = 'block';
    error = true;
  }

  if (!emailRegex.test(email.value)) {
    document.querySelector('#email-error').style.display = 'block';
    error = true;
  }

  if (!phone.value || !phoneRegex.test(phoneNumber) || phoneNumberError) {
    document.querySelector('#phone-error').style.display = 'block';
    error = true;
  }

  if(!postcode.value || !postcodeRegex.test(postcode.value)) {
    document.querySelector('#postcode-error').style.display = 'block';
    error = true;
  }

  if(preferredLanguage && !preferredLanguageItems.length >= 1) {
    document.getElementById('preferred-language-error').style.display = 'block';
    error = true;
  }

  if (file.files.length >= 1 && file.files[0].size > fileMaxSize) {
    document.getElementById('file-size-error').style.display = 'block';
    error = true;
  }

  if (weekends.length) {
    let selectedWeekendValue = null;

    for (let i = 0; i < weekends.length; i++) {
      if (weekends[i].checked) {
        selectedWeekendValue = weekends[i].value;
        break;
      }
    }

    // if(selectedWeekendValue != "yes") {
    //   document.querySelector('#weekends-error').style.display = 'block';
    //   error = true;
    // }
  }

  if (self_employed.length) {
    let selectedSelfEmployedValue = null;

    for (let j = 0; j < self_employed.length; j++) {
      if (self_employed[j].checked) {
        selectedSelfEmployedValue = self_employed[j].value;
        break;
      }
    }

    if (!selectedSelfEmployedValue) {
      document.querySelector('#self-employed-error').style.display = 'block';
      error = true;
    }
  }

  if (!start_date.value || new Date(start_date.value) < start_date_min_date) {
    document.querySelector('#start-date-error').style.display = 'block';
    error = true;
  }

  if (!contact.checked) {
    document.querySelector('#contact-error').style.display = 'block';
    error = true;
  }

  if (error) {
    e.preventDefault();
    grecaptcha.reset();
  } else if (token) {
    document.getElementById('application-form').submit();
  } else {
    grecaptcha.execute();
    console.error('Error: Invalid reCAPTCHA token', token);
  }
}

const applicationForm = document.getElementById('application-form');

if (applicationForm) {
  applicationForm.addEventListener('submit', function(e) {
    e.preventDefault();
    window.reCaptchaEvent = e;
    onSubmitFormApplication(e);
  });
}

// ------------------------------------
// EXTENDED FORM VALIDATIONS
// ------------------------------------

// const fileInputField = document.getElementById('file');

// if (fileInputField) {
// fileInputField.addEventListener('change', function(event) {
//   const file = event.target.files[0];
//   const validTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
//   const maxSize = 15 * 1024 * 1024;

//   if (file) {
//       const fileSize = file.size;

//       if (fileSize > maxSize) {
//         document.getElementById('file-size-error').style.display = 'block';
//       } else {
//         document.getElementById('file-size-error').style.display = 'none';
//       }

//       if (!validTypes.includes(file.type)) {
//         document.getElementById('file-invalid-type-error').style.display = 'block';
//       } else {
//         document.getElementById('file-invalid-type-error').style.display = 'none';
//       }
//   }
// });
// }

// ------------------------------------
// MULTISELECT
// https://codeshack.io/multi-select-dropdown-html-javascript/
// ------------------------------------
class MultiSelect {
  constructor(element, options = {}) {
    const defaults = {
      placeholder: '',
      max: null,
      search: false,
      selectAll: false,
      listAll: true,
      name: '',
      width: '',
      height: '',
      dropdownWidth: '',
      dropdownHeight: '',
      data: [],
      onChange() {},
      onSelect() {},
      onUnselect() {},
    };
    this.options = Object.assign(defaults, options);
    this.selectElement = typeof element === 'string' ? document.querySelector(element) : element;
    for (const prop in this.selectElement.dataset) {
      if (this.options[prop] !== undefined) {
        this.options[prop] = this.selectElement.dataset[prop];
      }
    }
    this.name = this.selectElement.getAttribute('name') ? this.selectElement.getAttribute('name') : `multi-select-${Math.floor(Math.random() * 1000000)}`;
    if (!this.options.data.length) {
      const options = this.selectElement.querySelectorAll('option');
      for (let i = 0; i < options.length; i++) {
        this.options.data.push({
          value: options[i].value,
          text: options[i].innerHTML,
          selected: options[i].selected,
          html: options[i].getAttribute('data-html'),
        });
      }
    }
    this.element = this._template();
    this.selectElement.replaceWith(this.element);
    this._updateSelected();
    this._eventHandlers();
  }

  _template() {
    let optionsHTML = '';
    for (let i = 0; i < this.data.length; i++) {
      optionsHTML += `
        <div class="multi-select-option${this.selectedValues.includes(this.data[i].value) ? ' multi-select-selected' : ''}" data-value="${this.data[i].value}">
          <span class="multi-select-option-radio"></span>
          <span class="multi-select-option-text">${this.data[i].html ? this.data[i].html : this.data[i].text}</span>
        </div>
      `;
    }
    let selectAllHTML = '';
    if (this.options.selectAll === true || this.options.selectAll === 'true') {
      selectAllHTML = `<div class="multi-select-all">
        <span class="multi-select-option-radio"></span>
        <span class="multi-select-option-text">Select all</span>
      </div>`;
    }
    const template = `
      <div class="multi-select ${this.name}"${this.selectElement.id ? ` id="${this.selectElement.id}"` : ''} style="${this.width ? `width:${this.width};` : ''}${this.height ? `height:${this.height};` : ''}">
        ${this.selectedValues.map((value) => `<input type="hidden" name="${this.name}[]" value="${value}">`).join('')}
        <div class="multi-select-header" style="${this.width ? `width:${this.width};` : ''}${this.height ? `height:${this.height};` : ''}">
          <span class="multi-select-header-max">${this.options.max ? `${this.selectedValues.length}/${this.options.max}` : ''}</span>
          <span class="multi-select-header-placeholder">${this.placeholder}</span>
        </div>
        <div class="multi-select-options" style="${this.options.dropdownWidth ? `width:${this.options.dropdownWidth};` : ''}${this.options.dropdownHeight ? `height:${this.options.dropdownHeight};` : ''}">
          ${this.options.search === true || this.options.search === 'true' ? '<input type="text" class="multi-select-search" placeholder="Search...">' : ''}
          ${selectAllHTML}
          ${optionsHTML}
        </div>
      </div>
    `;
    const element = document.createElement('div');
    element.innerHTML = template;
    return element;
  }

  _eventHandlers() {
    const headerElement = this.element.querySelector('.multi-select-header');
    this.element.querySelectorAll('.multi-select-option').forEach((option) => {
      option.onclick = () => {
        let selected = true;
        if (!option.classList.contains('multi-select-selected')) {
          if (this.options.max && this.selectedValues.length >= this.options.max) {
            return;
          }
          option.classList.add('multi-select-selected');
          if (this.options.listAll === true || this.options.listAll === 'true') {
            headerElement.insertAdjacentHTML('afterbegin', `<span class="multi-select-header-option" data-value="${option.dataset.value}">${option.querySelector('.multi-select-option-text').innerHTML}</span>`);
          }
          this.element.querySelector('.multi-select').insertAdjacentHTML('afterbegin', `<input type="hidden" name="${this.name}[]" value="${option.dataset.value}">`);
          this.data.filter((data) => data.value == option.dataset.value)[0].selected = true;
        } else {
          option.classList.remove('multi-select-selected');
          this.element.querySelectorAll('.multi-select-header-option').forEach((headerOption) => (headerOption.dataset.value == option.dataset.value ? headerOption.remove() : ''));
          this.element.querySelector(`input[value="${option.dataset.value}"]`).remove();
          this.data.filter((data) => data.value == option.dataset.value)[0].selected = false;
          selected = false;
        }
        if (this.options.listAll === false || this.options.listAll === 'false') {
          if (this.element.querySelector('.multi-select-header-option')) {
            this.element.querySelector('.multi-select-header-option').remove();
          }
          headerElement.insertAdjacentHTML('afterbegin', `<span class="multi-select-header-option">${this.selectedValues.length} selected</span>`);
        }
        if (!this.element.querySelector('.multi-select-header-option')) {
          headerElement.insertAdjacentHTML('afterbegin', `<span class="multi-select-header-placeholder">${this.placeholder}</span>`);
        } else if (this.element.querySelector('.multi-select-header-placeholder')) {
          this.element.querySelector('.multi-select-header-placeholder').remove();
        }
        if (this.options.max) {
          this.element.querySelector('.multi-select-header-max').innerHTML = `${this.selectedValues.length}/${this.options.max}`;
        }
        if (this.options.search === true || this.options.search === 'true') {
          this.element.querySelector('.multi-select-search').value = '';
        }
        this.element.querySelectorAll('.multi-select-option').forEach((option) => option.style.display = 'flex');
        // headerElement.classList.remove('multi-select-header-active');
        this.options.onChange(option.dataset.value, option.querySelector('.multi-select-option-text').innerHTML, option);
        if (selected) {
          this.options.onSelect(option.dataset.value, option.querySelector('.multi-select-option-text').innerHTML, option);
        } else {
          this.options.onUnselect(option.dataset.value, option.querySelector('.multi-select-option-text').innerHTML, option);
        }
      };
    });
    headerElement.onclick = () => headerElement.classList.toggle('multi-select-header-active');
    if (this.options.search === true || this.options.search === 'true') {
      const search = this.element.querySelector('.multi-select-search');
      search.oninput = () => {
        this.element.querySelectorAll('.multi-select-option').forEach((option) => {
          option.style.display = option.querySelector('.multi-select-option-text').innerHTML.toLowerCase().indexOf(search.value.toLowerCase()) > -1 ? 'flex' : 'none';
        });
      };
    }
    if (this.options.selectAll === true || this.options.selectAll === 'true') {
      const selectAllButton = this.element.querySelector('.multi-select-all');
      selectAllButton.onclick = () => {
        const allSelected = selectAllButton.classList.contains('multi-select-selected');
        this.element.querySelectorAll('.multi-select-option').forEach((option) => {
          const dataItem = this.data.find((data) => data.value == option.dataset.value);
          if (dataItem && ((allSelected && dataItem.selected) || (!allSelected && !dataItem.selected))) {
            option.click();
          }
        });
        selectAllButton.classList.toggle('multi-select-selected');
      };
    }
    if (this.selectElement.id && document.querySelector(`label[for="${this.selectElement.id}"]`)) {
      document.querySelector(`label[for="${this.selectElement.id}"]`).onclick = () => {
        headerElement.classList.toggle('multi-select-header-active');
      };
    }
    document.addEventListener('click', (event) => {
      if (!event.target.closest(`.${this.name}`) && !event.target.closest(`label[for="${this.selectElement.id}"]`)) {
        headerElement.classList.remove('multi-select-header-active');
      }
    });
  }

  _updateSelected() {
    if (this.options.listAll === true || this.options.listAll === 'true') {
      this.element.querySelectorAll('.multi-select-option').forEach((option) => {
        if (option.classList.contains('multi-select-selected')) {
          this.element.querySelector('.multi-select-header').insertAdjacentHTML('afterbegin', `<span class="multi-select-header-option" data-value="${option.dataset.value}">${option.querySelector('.multi-select-option-text').innerHTML}</span>`);
        }
      });
    } else if (this.selectedValues.length > 0) {
      this.element.querySelector('.multi-select-header').insertAdjacentHTML('afterbegin', `<span class="multi-select-header-option">${this.selectedValues.length} selected</span>`);
    }
    if (this.element.querySelector('.multi-select-header-option')) {
      this.element.querySelector('.multi-select-header-placeholder').remove();
    }
  }

  get selectedValues() {
    return this.data.filter((data) => data.selected).map((data) => data.value);
  }

  get selectedItems() {
    return this.data.filter((data) => data.selected);
  }

  set data(value) {
    this.options.data = value;
  }

  get data() {
    return this.options.data;
  }

  set selectElement(value) {
    this.options.selectElement = value;
  }

  get selectElement() {
    return this.options.selectElement;
  }

  set element(value) {
    this.options.element = value;
  }

  get element() {
    return this.options.element;
  }

  set placeholder(value) {
    this.options.placeholder = value;
  }

  get placeholder() {
    return this.options.placeholder;
  }

  set name(value) {
    this.options.name = value;
  }

  get name() {
    return this.options.name;
  }

  set width(value) {
    this.options.width = value;
  }

  get width() {
    return this.options.width;
  }

  set height(value) {
    this.options.height = value;
  }

  get height() {
    return this.options.height;
  }
}

document.querySelectorAll('[data-multi-select]').forEach((select) => new MultiSelect(select));

// ------------------------------------
// VWO EVENTS
// ------------------------------------
function handleRoleClick(role, ajaxUrl, userId, campaignID, eventLabel) {
  role.addEventListener('click', async () => {
    const rawResponse = await fetch(ajaxUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        action: 'vwo_ajax',
        userId: userId,
        eventPropLabel: 'clicked',
        eventPropValue: true,
        eventLabel: eventLabel,
        campaignID: campaignID,
      }),
    });
    const content = await rawResponse.json();
  });
}

// Track Job Role Page Visits (on Role page)
// if(document.body.classList.contains('page-template-tpl-role')) {
//   console.log('Job Role Page Visit');
//   // VWO.event("serverSideEvents", {
// 	// 	"jobRolePageVisits": 1
// 	// });
// }

// Track Application Form Start (on Role page and First Name field clicked)
// const input = document.querySelector('input#first-name');

// if (input) {
//   input.addEventListener('input', formStarted);
// }

// async function formStarted() {
//   if (document.body.classList.contains('page-template-tpl-role')) {
//     const rawResponse = await fetch(theme_variables.ajax_url, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded',
//       },
//       body: new URLSearchParams({
//         action: 'vwo_ajax',
//         userId,
//         eventPropLabel: 'started',
//         eventPropValue: true,
//         eventLabel: 'applicationFormStarted',
//         campaignID,
//       }),
//     });
//     const content = await rawResponse.json();
//     console.log('Application Form Start');
//     console.log(content);
//     input.removeEventListener('input', formStarted);
//   }
// }

// Track Application Submission Clicks (on Role page and Submit Application button clicked)
const applicationSubmit = document.getElementById('application-submit');

if (applicationSubmit) {
  applicationSubmit.addEventListener('click', formSubmitted);
}

async function formSubmitted() {
  if (document.body.classList.contains('page-template-tpl-role')) {
    // const rawResponse = await fetch(theme_variables.ajax_url, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded',
    //   },
    //   body: new URLSearchParams({
    //     action: 'vwo_ajax',
    //     userId,
    //     eventPropLabel: 'clicked',
    //     eventPropValue: true,
    //     eventLabel: 'submitApplicationClicked',
    //     campaignID,
    //   }),
    // });
    // console.log('Application Submitted');
    // const content = await rawResponse.json();
    // console.log(content);

    applicationSubmit.removeEventListener('input', formSubmitted);
  }
}

// Track Application Success (on Application Successful page)
// const url = window.location.href;
// if( url.match('application-successful') ) {
//   console.log('Application Success');
//   // VWO.event("serverSideEvents", {
// 	// 	"applicationSuccess": 1
// 	// });
// }

// Track Find a Role button clicks
// const headerbutton = document.querySelectorAll('a.pg-header__cta');
// headerbutton.forEach(el => el.addEventListener('click', event => {
//   console.log('Find a Role Click');
//   VWO.event("ctaButton-FindARole", {
// 		"clicked": 1
// 	});
// }));

// const standardApplyBtn = document.querySelector('#standard-apply-btn');
//
// if (standardApplyBtn) {
//   standardApplyBtn.addEventListener('click', async () => {
//     const rawResponse = await fetch(theme_variables.ajax_url, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded',
//       },
//       body: new URLSearchParams({
//         action: 'vwo_ajax',
//         userId,
//         eventPropLabel: 'clicked',
//         eventPropValue: true,
//         eventLabel: 'applyNowButtonClicked',
//         campaignID,
//       }),
//     });
//     console.log('Standard apply button clicked');
//     const content = await rawResponse.json();
//     console.log(content);
//   });
// }

// const stickyApplyBtn = document.querySelector('.sticky-cta .btn');
//
// if (stickyApplyBtn) {
//   stickyApplyBtn.addEventListener('click', async () => {
//     const rawResponse = await fetch(theme_variables.ajax_url, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded',
//       },
//       body: new URLSearchParams({
//         action: 'vwo_ajax',
//         userId,
//         eventPropLabel: 'clicked',
//         eventPropValue: true,
//         eventLabel: 'applyNowButtonClicked',
//         campaignID,
//       }),
//     });
//     console.log('Sticky apply button clicked');
//     const content = await rawResponse.json();
//     console.log(content);
//   });
// }

// const roleSearchResults = document.querySelector('.role-search-results');
// if (roleSearchResults) {
//   const roles = roleSearchResults.querySelectorAll('.role');
//   for (const role of roles) {
//     if (userId && campaignID) {
//       handleRoleClick(role, theme_variables.ajax_url, userId, campaignID, 'jobRoleClicked');
//     }
//   }
// }
